import { Conversation } from '@/models/conversation';
import { fetcher } from '@/config/api';

export interface SearchConversationsParams {
  search?: string;
  from_date?: string;
  to_date?: string;
  favorites_only?: boolean;
  limit?: number;
  offset?: number;
}

export interface SearchConversationsResponse {
  conversations: (Conversation & { preview?: string })[];
  total: number;
  has_more: boolean;
}

export interface BulkDeleteResponse {
  deleted_count: number;
  errors: { id: string; error: string }[];
}

export const listConversations = async (): Promise<Conversation[]> => {
  return fetcher<Conversation[]>('/api/conversations');
};

export const searchConversations = async (params: SearchConversationsParams): Promise<SearchConversationsResponse> => {
  const queryParams = new URLSearchParams();
  
  if (params.search) queryParams.append('search', params.search);
  if (params.from_date) queryParams.append('from_date', params.from_date);
  if (params.to_date) queryParams.append('to_date', params.to_date);
  if (params.favorites_only) queryParams.append('favorites_only', 'true');
  if (params.limit) queryParams.append('limit', params.limit.toString());
  if (params.offset) queryParams.append('offset', params.offset.toString());
  
  const queryString = queryParams.toString();
  const url = `/api/conversations/search${queryString ? `?${queryString}` : ''}`;
  
  return fetcher<SearchConversationsResponse>(url);
};

export const bulkDeleteConversations = async (conversationIds: string[]): Promise<BulkDeleteResponse> => {
  return fetcher<BulkDeleteResponse>('/api/conversations/bulk', {
    method: 'DELETE',
    body: JSON.stringify({ conversation_ids: conversationIds }),
  });
};

export const createConversation = async (data: { title: string; agent_key?: string }): Promise<Conversation> => {
  return fetcher<Conversation>('/api/conversations', {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

export const updateConversation = async (conversationId: string, updates: Partial<Conversation>): Promise<Conversation> => {
  return fetcher<Conversation>(`/api/conversations/${conversationId}`, {
    method: 'PUT',
    body: JSON.stringify(updates),
  });
};

export const deleteConversation = async (conversationId: string): Promise<Conversation[]> => {
  return fetcher<Conversation[]>(`/api/conversations/${conversationId}`, {
    method: 'DELETE',
  });
};

export const selectConversation = async (conversationId: string, previousConversationId?: string): Promise<{ status: string, message: string }> => {
  return fetcher<{ status: string, message: string }>(`/api/conversations/${conversationId}/select`, {
    method: 'POST',
    body: JSON.stringify({ previous_conversation_id: previousConversationId }),
  });
};